import BtnDownloadComponent from "./BtnDownload";
import BtnCloseComponent from "./BtnClose";
import BtnShareComponent from "./BtnShare";
import PopupFrameComponent from "./PopupFrame";
import BtnPlayVideoComponent from "./BtnPlayVideo";
import PopupPosterComponent from "./PopupPoster";
import ShowcaseVideoComponent from "./ShowcaseVideo";

export const BtnDownload = BtnDownloadComponent;
export const BtnClose = BtnCloseComponent;
export const BtnShare = BtnShareComponent;
export const PopupFrame = PopupFrameComponent;
export const BtnPlayVideo = BtnPlayVideoComponent;
export const PopupPoster = PopupPosterComponent;
export const ShowcaseVideo = ShowcaseVideoComponent;
